import { defineStore } from 'pinia'
import _ from 'lodash'
import { useCookies } from '@vueuse/integrations/useCookies'

export const useGlobalStore = defineStore('global', {
	state: () => {
		return {
			mobile: false,
			cart: false,
			modal: {
				name: null,
				payload: null,
				canClose: true,
			},
			platforms: [],
			countries: [],
		}
	},
	getters: {
		//
	},
	actions: {
		toggleMobile(delta) {
			delta != null ? (this.mobile = delta) : (this.mobile = !this.mobile)
		},
		setup() {
			this.ftue()
			this.getPlatforms()
			this.getCountries()
		},
		ftue() {
			const cookies = useCookies(['ftue'])
			if (!cookies.get('ftue')) {
				this.openModal('FTUE')
				cookies.set('ftue', true, { maxAge: 2419200 })
			}
		},
		getPlatforms() {
			return axios
				.get('/api/platforms')
				.then((platforms) => {
					this.platforms = platforms.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getCountries() {
			return axios
				.get('/api/countries')
				.then((countries) => {
					this.countries = countries.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		openModal(modal) {
			this.modal = {
				name: modal,
				payload: null,
				canClose: true,
			}
			document.body.classList.add('overflow-hidden')
		},
		setModal(modal) {
			this.modal = {
				name: modal[0],
				payload: modal[1],
				canClose: modal[2] ?? true,
			}
			document.body.classList.add('overflow-hidden')
		},
		closeModal() {
			this.modal = {
				name: null,
				payload: null,
				canClose: true,
			}
			document.body.classList.remove('overflow-hidden')
		},
	},
})
